import {
    GetFormalOffersResponse,
    GetIwocapayPaymentLaterResponse
} from '@iwoca/lapi-client/edge';

import { is30DaysOffer } from '../mapOfferDurationToMonths';
import { useGetDrawDownRepaymentScheduleIwocapay } from '../scheduledView/useGetDrawDownRepaymentSchedule';

export function useDrawDownRepaymentScheduleIwocaPay({
    offer,
    payLink
}: {
    offer: NonNullable<
        GetFormalOffersResponse['data']
    >['formal_offers'][number];
    payLink: GetIwocapayPaymentLaterResponse['data'][number];
}) {
    const {
        drawDownRepaymentScheduleIwocapay,
        loadingDrawDownRepaymentScheduleIwocapay
    } = useGetDrawDownRepaymentScheduleIwocapay({
        payLink,
        offer
    });

    if (!offer) {
        return {
            drawDownRepaymentScheduleIwocapay: undefined,
            monthlyRepayment: undefined,
            interestRate: undefined,
            loadingDrawDownRepaymentScheduleIwocapay
        };
    }

    const monthlyRepayment = is30DaysOffer(offer)
        ? drawDownRepaymentScheduleIwocapay?.summary.total_payable
        : drawDownRepaymentScheduleIwocapay?.summary.simplified_schedule
              ?.equal_repayments?.amount!;

    const totalInterest =
        drawDownRepaymentScheduleIwocapay?.summary.total_interest!;

    const interestRate =
        totalInterest === 0 ? 0 : offer.interest_rates![0].rate!;

    return {
        drawDownRepaymentScheduleIwocapay,
        monthlyRepayment,
        interestRate,
        loadingDrawDownRepaymentScheduleIwocapay
    };
}
